import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner';

const API_BASE = import.meta.env.VITE_API_BASE_URL;
// Same default as the backend (GOOGLE_REVIEW_URL); used only if the API is unreachable.
const FALLBACK_REVIEW_URL = 'https://g.page/r/CUgZjiJY-SY8EAE/review';

// c.dezshop.ro/r/:token — the internal link from the WhatsApp review request.
// Records the click, then forwards to the Google review form. The customer
// must always end up on Google, even if the token is unknown or the API fails.
export default function ReviewRedirectPage() {
  const { token } = useParams();

  useEffect(() => {
    let cancelled = false;
    const go = (url) => { if (!cancelled) window.location.replace(url || FALLBACK_REVIEW_URL); };
    const timer = setTimeout(() => go(FALLBACK_REVIEW_URL), 2500);
    (async () => {
      try {
        if (!API_BASE || !token) { go(FALLBACK_REVIEW_URL); return; }
        const res = await fetch(`${API_BASE}/public/review-links/${encodeURIComponent(token)}/click`, {
          method: 'POST', keepalive: true,
        });
        const json = res.ok ? await res.json() : null;
        clearTimeout(timer);
        go(json?.url);
      } catch {
        clearTimeout(timer);
        go(FALLBACK_REVIEW_URL);
      }
    })();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [token]);

  return (
    <div className="max-w-[700px] mx-auto px-4 py-16 text-center">
      <LoadingSpinner />
      <p className="text-gray-700 mt-4">Vă redirecționăm către pagina de recenzii Google…</p>
      <p className="text-sm text-gray-500 mt-2">
        Dacă nu se deschide automat, <a className="underline" href={FALLBACK_REVIEW_URL}>apăsați aici</a>.
      </p>
    </div>
  );
}
